<template>
  <div class="cr-flex cr-flex-col gap-4">
    <div
      :class="{
        'support-ticket-button': true,
        'support-ticket-button--form-open': showSupportForm
      }"
    >
      <ClientHomeChatLinkButton
        class="spc-mt-1"
        data-testid="open-support-ticket-button"
        :icon="`fa-regular fa-file-${ticketSubmitted ? 'export' : 'lines'}`"
        :subtext="buttonSubText"
        text="Support Ticket Form"
        @click="showSupportForm = !showSupportForm"
      />
    </div>
    <TransitionExpand @after-enter="scrollFormIntoView">
      <div
        v-if="showSupportForm"
        class="cr-flex-grow"
      >
        <SupportForm
          :client-locations="supportLocations"
          :description="description"
          :disabled="ticketSubmitted"
          :issue="issue"
          :priority="priority"
          :selected-location="locationId"
          :selected-type="type"
          :ticket-types="supportTypes"
          @submit="handleSubmit($event)"
        />
      </div>
    </TransitionExpand>
  </div>
</template>

<script>
import SupportForm from './SupportForm.vue'
import { ClientSupportService } from '../services/api/modules/client_support_service'
import ClientHomeChatLinkButton from './ClientHomeChatLinkButton.vue'
import TransitionExpand from './TransitionExpand.vue'

export default {
  name: 'ClientHomePageSupportForm',
  components: {
    SupportForm,
    ClientHomeChatLinkButton,
    TransitionExpand,
  },
  props: {
    description: {
      type: String,
      required: true,
    },
    issue: {
      type: String,
      required: true,
    },
    priority: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    locationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      supportLocations: [],
      supportTypes: [],
      showSupportForm: true,
      ticketSubmitted: false,
    }
  },
  computed: {
    buttonSubText() {
      if (!this.ticketSubmitted) {
        return `Click to ${this.showSupportForm ? 'close' : 'view'}`
      }
      return 'Ticket submitted'
    },
  },
  mounted() {
    this.fetchHubspotTypesAndLocations(this.$props)
  },
  methods: {
    handleSubmit(status) {
      if (status === 'success') {
        this.$toast.success('Ticket submitted successfully! It can take a few minutes for your support ticket to show in the Support Center, but we\'re on it!')
        this.ticketSubmitted = true
        return
      }

      this.$toast.error('Ticket submission failed. Please try again.')
    },
    async fetchHubspotTypesAndLocations() {
      try {
        const [locations, ticketTypes] = await Promise.all([
          ClientSupportService.fetchClientLocations(),
          ClientSupportService.fetchTicketTypes(),
        ])

        this.supportTypes = ticketTypes.data
        this.supportLocations = locations.data
      } catch (err) {
        this.error = err?.response?.data?.message || err.message || 'Something went wrong. Please try again.'
        this.$toast.error(this.error)
      }
    },
    scrollFormIntoView() {
      const supportTicketButton = document.querySelector('[data-testid=open-support-ticket-button]')
      supportTicketButton.scrollIntoView()
    },
  },
}
</script>

<style lang="scss" scoped>
.support-ticket-button {
  &--form-open {
    padding-bottom: var(--space-4);
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
}
</style>
